import ActiveRoleplay from "./ActiveRoleplay";

export default function EmbeddedActiveRoleplay() {
  return <ActiveRoleplay isEmbedded />;
}
